<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado v-if="encabezado" :elementos="encabezado" :action="action" />
      <v-card>
        <v-card-text>
          <div
            name="table"
            v-if="showAction(1) && table"
            :class="[list.length < 6 ? 'calendar' : '']"
          >
            <v-row class="pl-5 pr-5">
              <v-col
                cols="12"
                sm="12"
                md="2"
                lg="2"
                class="pt-3"
                v-if="filterModality"
              >
                <branch-offices-list
                  :model="idBranchOfficeSelected"
                  v-on:triggerChange="branchOfficeSelected"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" v-if="filterDate">
                <vc-date-picker
                  color="green"
                  v-model="range"
                  is-range
                  :max-date="new Date()"
                >
                  <template v-slot="{ inputEvents }">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="rangeComputed"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                      @click:append="clearCalendar"
                      :disabled-input="validData"
                      label="Fecha..."
                      single-line
                      outlinedx
                      hide-details
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="2"
                lg="2"
                class="d-flex justify-center mt-4"
                v-if="!hideButtonAdd"
              >
                <template v-slot="{ inputEvents }">
                  <v-text-field
                    v-on="inputEvents.start"
                    :value="rangeComputed"
                    :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                    @click:append="clearCalendar"
                    :disabled-input="validData"
                    label="Fecha..."
                    single-line
                    outlinedx
                    hide-details
                  ></v-text-field>
                </template>
              </v-col>
              <v-col cols="12" md="2" sm="12" v-if="this.history">
                <v-autocomplete
                  v-model="biRadsSelect"
                  :items="listBiradsFilter"
                  item-text="text"
                  item-value="idBirads"
                  auto-select-first
                  clearable
                  label="BI-RADS"
                  @change="listAllPagination()"
                  no-data-text="Sin resultados disponibles"
                />
              </v-col>
              <v-col cols="12" md="2" sm="12" lg="2">
                <v-autocomplete
                  v-model="modalitiesSelect"
                  :items="modalities"
                  item-text="name"
                  item-value="idModality"
                  auto-select-first
                  clearable
                  label="Modalidad"
                  @change="listAllPagination()"
                  no-data-text="Sin resultados disponibles"
                />
              </v-col>
              
               <v-col
                cols="12"
                sm="12"
                :md="showEstatusSelect ? 2 : 4"
                :lg="showEstatusSelect ? 2 : 4"
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  outlinedx
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="2"
                lg="2"
                v-if="showEstatusSelect"
                class="d-flex align-center"
              >
                <v-select
                  v-model="revalidatedFilter"
                  :items="revalidatedOptions"
                  item-text="text"
                  item-value="value"
                  label="Estatus"
                  outlinedx
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <component
              class="mt-2"
              :key="tableKey"
              :get="get"
              :listAllPagination="listAllPagination"
              :unlockStudy="unlockStudy"
              :idBranchOffice="idBranchOfficeSelected"
              :list="filteredList"
              :is="table"
              :currentPage="currentPage"
              :range="range"
              :biRadsSelect="biRadsSelect"
              :modalitiesSelect="modalitiesSelect"
              :search="search"
              :totalCount="totalCount"
              :getAddendums="getAddendums"
              :showProductivoRevalidacionBtn="showProductivoRevalidacionBtn"
              :revalidatedFilter="revalidatedFilter"
              @colposcopyLoaded="onColposcopyLoaded"
              @colposcopyFilesLoaded="handleFilesLoaded"
            />
            <v-row dense>
              <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                <paginatesx
                  :click-handler="changePage"
                  :page-count="pageCount"
                  :page-range="1"
                  :margin-pages="1"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginatesx>
              </v-col>
              <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                <v-banner outlined single-line>
                  Total: {{ totalCount }}</v-banner
                >
              </v-col>
            </v-row>
          </div>

          <div name="form" v-if="(showAction(2) || showAction(3)) && form">
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent="undefined">
                <component
                  :is="form"
                  key="form"
                  :model="model"
                  :modelDialog="modelDialog"
                  :idMedicalPractice="idMedicalPractice"
                  @returnTable="returnTable"
                  @ActiveButtonSave="ActiveButtonSave"
                  :saveFilesChanges="saveFilesChanges"
                  @filesSelected= "model.filesList = $event"
                  @colposcopyFilesLoaded="model.colposcopyFiles = $event.map(f => ({ fileName: f.fileName, base64: f.bytes }))"
                  :buttonBirads="buttonBirads"
                  :mastography="mastography"
                  :isMammography="isMammography"
                />
                <div class="separator20-50"></div>
                <div class="text-center justify-center">
                  <v-col class="justify-space-around">
                    <v-menu
                      offset-x
                      bottom
                      left
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mr-12 mb-4"
                          :disabled="sending"
                          outlined
                          color="error"
                          depressed
                          v-bind="attrs"
                          v-on="{ ...menu }"
                          @click="confirmationReturn()"
                        >
                          <v-icon left> mdi-keyboard-backspace </v-icon>
                          Volver
                        </v-btn>
                      </template>
                    </v-menu>
                    <v-menu
                      offset-x
                      bottom
                      rigth
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mb-4"
                          :disabled="invalid || !biradsButtonFill"
                          v-bind="attrs"
                          depressed
                          v-on="{ ...menu }"
                          color="primary"
                          @click="confirmationSave()"
                        >
                          {{ saveButtonText }}
                          <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </div>
              </v-form>
            </validation-observer>
          </div>

          <div name="addenumViewer" v-if="showAction(4)">
            <component
              :is="addenumViewer"
              key="addenumViewer"
              :addendums="addendums"
              :model="model"
            />
            <div class="separator20-50"></div>

            <div class="text-center justify-center">
              <v-col class="justify-space-around">
                <v-menu
                  offset-x
                  bottom
                  :close-on-content-click="true"
                  rounded="lg"
                >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-btn
                      type="button"
                      class="mr-12 mb-4"
                      :disabled="sending"
                      outlined
                      color="error"
                      depressed
                      v-bind="attrs"
                      v-on="{ ...menu }"
                      @click="confirmationReturn()"
                    >
                      <v-icon left> mdi-close </v-icon>
                      volver
                    </v-btn>
                  </template>
                </v-menu>
              </v-col>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="swalDialog" persistent></v-dialog>
      <!-- <v-dialog persistent v-model="addWithPDF">
          <component
            key="pdfModal"
            :is="pdfModal"
            :model="model"
            @returnTable="returnTable"
            :addWithPDF="addWithPDF"
          />
        </v-dialog> -->
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import BranchOfficesList from "@/components/BranchOfficesList.vue";
import {
  PatientFileRequest,
  ModaltyRequest,
  InterpretationHistoryRequest,
  BiradsRequest,
  StudyRequest
} from "@/core/request";
import InterpretationService from "@/app/services/InterpretationService";
import InterpretationHistoryService from "@/app/services/InterpretationHistoryService";

export default {
  name: "CrudView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      tableKey: 0,
      cols: "col-md-3 col-xl-3 col-sm-12",
      idBranchOffice: null,
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {
      colposcopy: [], 
    },
      modelDialog: {},
      listBiradsFilter: [],
      encabezado: null,
      table: null,
      service: null,
      form: null,
      addenumViewer: null,
      cancelationDialog: null,
      search: null,
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      filterDate: false,
      filterModality: false,
      cancelationModal: false,
      generatePDFModal: false,
      saveButtonText: "",
      addButtonText: "",
      range: null,
      idBranchOfficeSelected: null,
      idMedicalPractice: "",
      saveFilesChanges: false,
      swalDialog: false,
      modalitiesSelect: null,
      biRadsSelect: null,
      modalities: [],
      speciality: 2,
      buttonBirads: false,
      mastography: false,
      files: undefined,
      history: false,
      addendums: [],
      biradsButtonFill: false,
      isMammography: false,
      mapping: {},
      revalidatedFilter: false,
      revalidatedOptions: [
        { text: "No revalidado", value: false },
        { text: "Revalidado", value: true },
      ],
      branchOfficesItems: []    
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
      // this.$session.set("suimsec_branch_offices", this.idBranchOffice);
      // this.updateBranchOffice(this.idBranchOffice);
    },
    idBranchOfficeState() {
      this.listAllPagination();
    },
    files(newFiles) {
      this.model.filesList = newFiles;
    },

    "$route.query.autoOpenId"() {
      this.intentarAutoAbrirFormulario();
    },

    revalidatedFilter() {
    if (!this.showEstatusSelect) return;

    this.currentPage = 1;
    this.listAllPagination();
  },
  },

 async mounted() {
    this.service = (await this.$route.meta.service()).default;
    this.table = (await this.$route.meta.table()).default;
    this.form = (await this.$route.meta.form()).default;

    if (this.$route.meta.addenumViewerFlag) {
      this.addenumViewer = (await this.$route.meta.addenumViewer()).default;
    }

    this.encabezado = this.$route.meta.header;
    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.filterDate = this.$route.meta.filterDate || false;
    this.filterModality = this.$route.meta.filterModality || false;
    this.cancelationModal = this.$route.meta.cancelationModal || false;
    this.generatePDFModal = this.$route.meta.generatePDFModal || false;
    this.history = this.$route.meta.history || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";

    const { autoOpenId, autoOpenType } = this.$route.query || {};
    if (autoOpenId && autoOpenType) {
      this.intentarAutoAbrirFormulario();
    } else {
      this.listAllPagination();
    }

    this.listAllModalities();
    this.listAllBirads();

    window.addEventListener("beforeunload", this.unlockRecord);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unlockRecord);
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),

    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${this.$utilFront.formatDate(
        this.range.start
      )} al ${this.$utilFront.formatDate(this.range.end)}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAllPagination();
      return true;
    },
    isColposcopy() {
    return this.model.nameModality?.toUpperCase() === 'COLPOSCOPIA';
  },
    filteredList() {
    return Array.isArray(this.list) ? this.list : [];
  },
  roleNormalized() {
    const roleRaw = (this.$utilFront.getRole?.() || "");
    return roleRaw
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  },
  showEstatusSelect() {
    return this.history && this.isMesaDeControl;
  },
   showProductivoRevalidacionBtn() {
    return this.history && this.revalidatedFilter === true;
  },

  roleNormalized() {
    const roleRaw = (this.$utilFront.getRole?.() || "");
    return roleRaw
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  },

  isMesaDeControl() {
    return this.roleNormalized === "mesa de control";
  },

  isMedicoInterpreteSupervisor() {
    return this.roleNormalized === "medico interprete supervisor";
  },

  },
  beforeRouteLeave(to, from, next) {
    this.unlockRecord();
    next();
  },
  methods: {
    unlockRecord() {
      this.unlockStudy(this.model.idStudy);
    },
    ActiveButtonSave(value) {
      this.biradsButtonFill = value;
    },
    onColposcopyLoaded(newData) {
  this.model.colposcopy = newData;
},

handleFilesLoaded(response) {
    const raw = response.studyFiles || [];
    this.model.colposcopyFiles = raw.map(f => ({
      fileName: f.fileName,
      base64:  f.bytes
    }));
  },
    listAllBirads() {
      this.listBiradsFilter = [];
      BiradsRequest.listAll()
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && Array.isArray(data)) {
            this.listBiradsFilter = data.map((obj) => {
              return {
                // value: { idBirads: obj.idBirads },
                text: obj.name,
                idBirads: obj.idBirads,
              };
            });
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },
    listAllModalities() {
      let post = {
        idSpeciality: this.speciality,
      };
      ModaltyRequest.listModaltyByHumanResourceAndSpecialty(post).then(
        (res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
        this.modalities = res.data.data
          .filter(mod => mod.idModality !== 'MPAP-01')
          .map(modality => ({
            idModality: modality.idModality,
            name:       `${modality.acronym} - ${modality.name}`,
            speciality: modality.speciality || '--- Sin información ---',
            acronym:    modality.acronym,
          }));
            // this.modalitiesSelect = res.data.data.map((modality) => {
            //   return {
            //     idModality: modality.idModality,
            //   };
            // });
          } else if (res.data.code === 401) {
          } else {
            this.modalities = [];
          }
        }
      );
    },
    confirmationReturn() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea regresar a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.buttonBirads = false;
          this.resetStatusInterpreting();
          this.changeAction(1);
          this.redirectToInterpretationList();
          this.biradsButtonFill = false;
        } else {
          this.swalDialog = false;
        }
      });
    },

  confirmationSave() {
      this.saveFilesChanges = true;

      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar la interpretación actual?",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.doAction();
        } else {
          this.swalDialog = false;
        }
      });
    },

    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    returnTable(e) {
      if (e) {
        this.changeAction(1);
        this.biradsButtonFill = false;
        this.buttonBirads = false;
        this.redirectToInterpretationList();
      }
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.biradsButtonFill = false;
        this.mastography = false;
        this.model = {};

        this.action = action;
        if (this.action != 2) {
          this.listAllPagination();
        }
      } else {
        this.action = action;
        this.checkMammography();
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
  this.sending = true;
  let params = {
    idBirads: this.biRadsSelect,
    search: this.search,
    maxResults: this.itemsPerPage,
    page: this.currentPage,
    idBranchOffice:
      this.idBranchOfficeSelected != null
        ? this.idBranchOfficeSelected
        : this.$utilFront.getIdBranchOffice(),
  };

   if (this.showEstatusSelect && (this.revalidatedFilter === true || this.revalidatedFilter === false)) {
    params.withRevalidation = this.revalidatedFilter;
  }
  
  if (this.$utilFront.nonEmpty(this.range)) {
    params.start = this.$utilFront.startOfDay(this.range.start);
    params.end = this.$utilFront.endOfDay(this.range.end);
  }
  if (this.$utilFront.nonEmpty(this.modalitiesSelect)) {
    params.idModality = this.modalitiesSelect;
  }

  if (this.history && this.isMesaDeControl) {
        params.withRevalidation = this.revalidatedFilter === true;
          }

  this.service
    .listAllPagination(params)
    .then((res) => {
      this.sending = false;
      let { list, count } = res.data;

      this.list = list.map((obj) => ({
        ...obj,
        isInterpretanding: this.isInterpretanding(obj.statusStudy),
      }));

      this.totalCount = count;
      this.pageCount = Math.ceil(count / this.itemsPerPage);
      if (!this.history) {
        this.tableKey += 1;
      }

      if (
        (count > 0 &&
          this.$utilFront.isEmptyList(list) &&
          this.currentPage > 1) ||
        this.currentPage > this.pageCount
      ) {
        this.changePage(1);
      }
    })
    .catch((e) => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},


    isInterpretanding(statusStudy) {
      return this.$cnst.STUDY_INTERPRETATING_STATUS === statusStudy;
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },
    sendAddendums(addendums, idInterpretation) {
      this.sending = true;

      this.specialCharacter();

      let formData = new FormData();

      formData.append("idInterpretation", idInterpretation);
      formData.append("idPatient", this.model.idPatient);

      addendums.forEach((file) => {
        let c = "";

        for (var i = 0, j = file.name.length; i < j; i++) {
          var l = file.name.charAt(i);
          c = c + (l in this.mapping ? this.mapping[l] : l);
        }
        let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");

        formData.append("files", file);
        formData.append("names", te);
      });

      PatientFileRequest.uploadFilesInterpretation(formData)
        .then((res) => {
          let { code } = res.data;
          if (code !== 200) {
            this.$utilFront.notifications(
              "Carga de archivos nos disponible",
              "WARNING"
            );
          }
        })
        .catch((e) => {
          this.$utilFront.errorhttp(e);
        })
        .finally(() => {
          this.interpretationSaved();
        });
    },
    interpretationSaved() {
      this.sending = false;
      this.listAllPagination();
      if (!this.isRevalidationRoute()) {
        this.$utilFront.notifications("Interpretación guardada.", "SUCCESS");
      }
        this.changeAction(1);
    },
    getAddendums(item, type) {
      let data = { idInterpretation: item.idInterpretation };
      this.model = item;
      try {
        InterpretationHistoryRequest.getAddendums(data)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && typeof data === "object") {
              this.addendums = data;
              this.addendums.map((addendum) => {
                addendum.name = addendum.fileName;
              });
              if (type == 1) {
                this.changeAction(4);
              }
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              this.$utilFront.notifications(data, "ERROR");
            } else {
              this.catchError();
              this.sending = false;
            }
          })
          .catch(() => {
            this.catchError();
          })
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
        this.sending = false;
      }
    },
    
   async add() {
  if (this.sending) return;
  this.sending = true;

  try {
    //  GUARDAR FORMULARIO DE COLPOSCOPIA
    if (
      Array.isArray(this.model.colposcopy) &&
      this.model.colposcopy.some(e => e.questions && e.questions.length > 0)
    ) {
      const payloadColposcopy = this.buildColposcopyPayload();
      await InterpretationService.saveColposcopyFormInterpretation(payloadColposcopy);
    }

    await this.uploadColposcopyFiles();

    // GUARDAR INTERPRETACIÓN
    let data;
    if (!this.buttonBirads) {
      data = {
        interpretation: this.model.interpretation,
        complement: this.model.complement,
        idStudy: this.model.idStudy,
        idHumanResource: this.$utilFront.getIdHumanResource(),
      };
    } else {
      data = {
        interpretation: this.model.interpretation,
        complement: this.model.complement,
        idStudy: this.model.idStudy,
        idHumanResource: this.$utilFront.getIdHumanResource(),
        idBirads: this.model?.birads?.idBirads,
        note: this.model.note,
        findingLocationTypeList: this.model.findingLocationTypeList,
      };
    }

    const response = await this.service.add(data);
    const { data: newInterpretationId, code } = response.data;

    if (code !== 200) {
      const msg = newInterpretationId || "Ocurrió un error durante el registro.";
      this.$utilFront.notifications(msg, "ERROR");
      return;
    }

    if (this.isRevalidationRoute()) {
      this.$utilFront.notifications("Revalidación guardada.", "SUCCESS");
    }

    if (this.redirigirDespuesDeGuardar()) return;

    this.interpretationSaved();

  } catch (error) {
    this.$utilFront.errorhttp(error);
  } finally {
    this.sending = false;
  }
},

base64ToBlob(base64, mimeType = 'application/pdf') {
    const byteChars = atob(base64);
    const byteNumbers = Array.from(byteChars).map(c => c.charCodeAt(0));
    return new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  },

  async uploadColposcopyFilesUpdate() {
  const existing = (this.model.colposcopyFiles || []).map(f => {
    const blob = this.base64ToBlob(f.base64 || f.bytes);
    return new File([blob], f.fileName, { type: 'application/pdf' });
  });

  const added = (this.model.filesList || []).filter(f => f instanceof File);

  const allFiles = [...existing, ...added];

  const formData = new FormData();
  formData.append('jsonData', JSON.stringify({ idStudy: this.model.idStudy }));

  if (allFiles.length) {
    allFiles.forEach(file => formData.append('files', file, file.name));
  }

  const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  if (resp?.status !== 200) {
    this.$utilFront.notifications('Error al actualizar archivos', 'ERROR');
    throw new Error('SaveFiles failed');
  }
},


async update() {
    if (this.sending) return;
    this.sending = true;

    try {
      if (
        this.isColposcopy &&
        Array.isArray(this.model.colposcopy) &&
        this.model.colposcopy.some(e => Array.isArray(e.questions) && e.questions.length > 0)
      ) {
        const payload = this.buildColposcopyPayload();
        await InterpretationHistoryRequest.editFormColposcopyFromInterpretation(payload);
      }

      if (this.isColposcopy) {
        await this.uploadColposcopyFilesUpdate();
      } else if (this.model.filesList?.length) {
        await this.sendAddendums(this.model.filesList, this.model.idInterpretation);
      }

      const data = !this.buttonBirads
        ? {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idInterpretation: this.model.idInterpretation,
            idHumanResource: this.$utilFront.getIdHumanResource(),
          }
        : {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idInterpretation: this.model.idInterpretation,
            idHumanResource: this.$utilFront.getIdHumanResource(),
            idBirads: this.model.birads?.idBirads,
            note: this.model.note,
            findingLocationTypeList: this.model.findingLocationTypeList,
          };

      const resp = await this.service.update(data);
      if (resp.data.code !== 200) {
        const msg = resp.data.data || "Ocurrió un error al actualizar.";
        this.$utilFront.notifications(msg, "ERROR");
        return;
      }

      if (this.isRevalidationRoute()) {
        this.$utilFront.notifications("Revalidación guardada.", "SUCCESS");
      }


      if (this.redirigirDespuesDeGuardar()) return;

      this.interpretationSaved();

    } catch (error) {
      this.$utilFront.errorhttp(error);

    } finally {
      this.sending = false;
      this.saveFilesChanges = false;
    }
  },

  async uploadColposcopyFiles() {
      const files = this.model.filesList || [];
      if (files.length === 0) return;

      const formData = new FormData();
      formData.append(
        "jsonData",
        JSON.stringify({ idStudy: this.model.idStudy })
      );
      for (const file of files) {
        formData.append("files", file, file.name);
      }

      const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (resp?.status !== 200) {
        this.$utilFront.notifications(
          "Error al adjuntar archivos",
          "ERROR"
        );
        throw new Error("SaveFiles failed");
      }
  },
  sendAddendums(addendums, idInterpretation) {
      this.sending = true;

      this.specialCharacter();

      let formData = new FormData();

      formData.append("idInterpretation", idInterpretation);
      formData.append("idPatient", this.model.idPatient);

      addendums.forEach((file) => {
        let c = "";

        for (var i = 0, j = file.name.length; i < j; i++) {
          var l = file.name.charAt(i);
          c = c + (l in this.mapping ? this.mapping[l] : l);
        }
        let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");

        formData.append("files", file);
        formData.append("names", te);
      });

      PatientFileRequest.uploadFilesInterpretation(formData)
        .then((res) => {
          let { code } = res.data;
          if (code !== 200) {
            this.$utilFront.notifications(
              "Carga de archivos no disponible",
              "WARNING"
            );
          }
        })
        .catch((e) => {
          this.$utilFront.errorhttp(e);
        })
        .finally(() => {
          this.interpretationSaved();
        });
    },


    buildColposcopyPayload() {
      const calculators = this.model.colposcopy.map(evaluation => {
        return {
          idCalculator: evaluation.idEvaluation,
          dataQuestions: evaluation.questions.map(q => {
            const obj = { idQuestion: q.idQuestion };
            if (q.answerClosed) {
              obj.idAnswer = q.answerClosed;
            }
            if (q.answersClosed?.length) {
              obj.answersClosed = q.answersClosed;
            }
            if (q.answerOpen && q.answerOpen.trim()) {
              obj.openAnswer = q.answerOpen;
            }
            return obj;
          }),
        };
      });
      return {
        calculators,
        idPerson: this.model.idPerson || null,
        idStudy: this.model.idStudy
      };
    },

    get(params, i) {
  this.sending = true;

  let sendparams;
  if (!this.history) {
    sendparams = { idStudy: params };
  } else {
    sendparams = { idInterpretation: params };
    this.biradsButtonFill = true;
  }

  this.service
    .get(sendparams)
    .then((response) => {
      let { data, code } = response.data;

      if (code === 200) {
        const updatedModel = { ...this.model, ...data };

        if (this.model.colposcopy && this.model.colposcopy.length > 0) {
          updatedModel.colposcopy = this.model.colposcopy;
        } else {
          updatedModel.colposcopy = data.colposcopy || [];
        }

        if (this.$route.name === "REVALIDATION-PENDING") {
          updatedModel.observation = null;


          updatedModel.complement = {
            ...(updatedModel.complement || {}),
            conclusion: null,
            diagnosticImpression: null,
            nextDetection: null,
            hasReference: null,
            ultrasound: null,
            referenceEvaluation: null,
            referenceDate: null,
          };
        }

        this.model = updatedModel;

        // --- lo demás igual ---
        this.modelDialog = {
          note: data.biradsNote,
          birads: data.idBirads,
          findingLocationTypeList: data.findingLocationTypeList,
        };

        this.model.birads = {
          name: data.birads,
          note: data.biradsNote,
          idBirads: data.idBirads,
        };

        this.model.note = data.biradsNote;
        this.model.findingLocationTypeList = data.findingLocationTypeList;

        if (this.model.requireBiradsReport === 1) {
          this.buttonBirads = true;
          this.mastography = true;
        } else {
          this.buttonBirads = false;
          this.biradsButtonFill = true;
        }

        this.changeAction(i);
      } else {
        data = data || "Ocurrió un error al obtener la información.";
        this.$utilFront.notifications(data, "ERROR");
      }
    })
    .catch((e) => this.$utilFront.errorhttp(e))
    .finally(() => (this.sending = false));
},

    clearCalendar() {
      this.range = "";
      this.listAllPagination();
    },
    resetStatusInterpreting() {
      let idStudy = this.model?.idStudy;
      if (this.$utilFront.nonEmpty(idStudy)) {
        InterpretationService.resetStatusInterpreting(idStudy)
          .then((response) => {
            this.listAllPagination();
          })
          .catch((e) => {
            this.$utilFront.errorhttp(e);
          });
      }
    },
    unlockStudy(idStudy) {
      // if (!this.sending) {
      // this.sending = true;

      if (
        this.$utilFront.nonEmpty(idStudy) &&
        this.$utilFront.isNonNull(this.service.unlockStudy)
      ) {
        this.service
          .unlockStudy(idStudy)
          .then((response) => {
            // this.sending = false;
            this.listAllPagination();
            // this.$utilFront.notifications(`Estudio ${idStudy} se ha desbloqueado correctamente.`, "SUCCESS");
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    checkMammography() {
      if (this.model) {
        let { nameStudy, nameModality } = this.model;
        this.isMammography =
          this.$cnst.IS_MOMMOGRAPHY(nameStudy) ||
          this.$cnst.IS_MOMMOGRAPHY(nameModality);
      }
    },
    validAddendums(addendums) {
      if (this.$utilFront.isEmptyList(addendums)) {
        return true;
      }

      let formData = new FormData();

      addendums.forEach((file) => {
        formData.append("files", file);
      });

      var res = Array.from(formData.entries(), ([key, prop]) => ({
        [key]: {
          ContentLength: typeof prop === "string" ? prop.length : prop.size,
        },
      }));

      let totalSize = 0;
      res.forEach((item) => {
        if (item.files && item.files.ContentLength) {
          totalSize += item.files.ContentLength;
        }
      });

      if (totalSize > this.$cnst.LIMIT_LOAD_FILES) {
        this.$utilFront.notifications(
          "Los archivos exceden el límite permido (10MB)",
          "ERROR"
        );
        return false;
      }

      return true;
    },
    intentarAutoAbrirFormulario() {
      const { autoOpenId, autoOpenType } = this.$route.query || {};
      if (!autoOpenId || !autoOpenType) return;

      const tipo = Number(autoOpenType);

      console.log("[InterpretationView] AUTO-OPEN:", { autoOpenId, tipo, route: this.$route.name });

      this.get(autoOpenId, tipo);

      const cleanUrl = this.$route.path; 
      window.history.replaceState({}, "", cleanUrl);
    },
    redirigirDespuesDeGuardar() {
      const rn = this.$route.name;

      if (rn === "REVALIDATION-HISTORY") {
        this.$router.replace({ name: "INTERPRETATION-HISTORY" });
        return true;
      }

      if (rn === "REVALIDATION-PENDING") {
        this.$router.replace({ name: "INTERPRETATION-HISTORY" });
        return true;
      }

      return false;
    },
     redirectToInterpretationList() {
    const map = {
      "REVALIDATION-HISTORY": "INTERPRETATION-HISTORY",
      "REVALIDATION-PENDING": "INTERPRETATION-HISTORY" 
    };

    const target = map[this.$route.name];
    if (!target) return;

    this.$router.replace({ name: target, query: {} }).catch(() => {});
  },
       isRevalidationRoute() {
      return this.$route.name === "REVALIDATION-HISTORY"
          || this.$route.name === "REVALIDATION-PENDING";
    },
  },
};
</script>
